const HUB_MESSAGE_TYPE = {
  GET_RESPONSE: 'getResponse',
  DELETE_RESOURCE: 'deleteResource',
};

const CLIENT_ORIGIN_WS_EVENTS = {
  COLLECTION: 'coll',
  SET_MESSAGE_STATUS: 'set_message_status',
  NOTIFICATION_SETTINGS: 'notification_settings',
};

const SERVER_ORIGIN_WS_EVENTS = {
  COLLECTION: 'coll',
  CHATBOT_NOTIFICATION: 'chatbot_notification',
};

export { HUB_MESSAGE_TYPE, CLIENT_ORIGIN_WS_EVENTS, SERVER_ORIGIN_WS_EVENTS };
